import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiUrlsEnum } from '../enums';
import { ICoupon, ICouponFilter, IPaginationResponse } from '../interfaces';
import { httpParamsUtil } from '../utils';
import { FileTransferService } from './file-transfer.service';
import {CouponesTableQueryDto} from "@core/dto/requests/coupones-table-query.dto";
import {TableGetResponseDto} from "@core/dto/responses/table-get-response.dto";

@Injectable()
export class CouponesDataService extends FileTransferService {

  public getCoupones(filter: CouponesTableQueryDto): Observable<TableGetResponseDto<ICoupon>> {
    const params = httpParamsUtil(filter);
    return this.http.get<IPaginationResponse<ICoupon>>(`${environment.host}${ApiUrlsEnum.coupones}`, {params});
  }
}
